import { combineReducers } from 'redux';
import { alerts } from './alerts.reducer';
import { employee } from './employee.reducer';
import { accountInfo } from './accountInfo.reducer';
import redirectURLSlice from './redirectURLSlice';
import licencesSlice from './licencesSlice';

const rootReducer = combineReducers({
  employee,
  alerts,
  accountInfo,
  redirectURLSlice,
  licencesSlice
});

export default rootReducer;
